import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

const buildQueryString = (filters = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      searchParams.append(key, value);
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

export const fetchQuotes = async (filters = {}) => {
  const res = await axios.get(`${API_URL}/quotes${buildQueryString(filters)}`, header());
  return res.data;
};

export const fetchQuote = async (id) => {
  const res = await axios.get(`${API_URL}/quotes/${id}`, header());
  return res.data;
};

export const createQuote = async (payload) => {
  const res = await axios.post(`${API_URL}/quotes`, payload, header());
  return res.data;
};

export const replaceQuote = async (id, payload) => {
  const res = await axios.put(`${API_URL}/quotes/${id}`, payload, header());
  return res.data;
};

export const updateQuote = async (id, payload) => {
  const res = await axios.patch(`${API_URL}/quotes/${id}`, payload, header());
  return res.data;
};

export const deleteQuote = async (id) => {
  const res = await axios.delete(`${API_URL}/quotes/${id}`, header());
  return res.data;
};

const QuoteService = {
  fetchQuotes,
  fetchQuote,
  createQuote,
  replaceQuote,
  updateQuote,
  deleteQuote,
};

export default QuoteService;
